// The one-shot probe of the tenant feature `announcements` (#164,
// src/core/announcementFeature.ts). It asks CORE for the competitions' enabled
// feature slugs — it is not an announcement operation, so it can never hit the
// notification subgraph's "announcements are not enabled" refusal or its 401.
import { graphql } from 'src/graphql'

export const AnnouncementFeatureProbeDocument = graphql(/* GraphQL */ `
  query AnnouncementFeatureProbe {
    competitions {
      id
      slug
      name
      features
    }
  }
`)
